import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-merchant-ad-config",
  "use": "icon-merchant-ad-config-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-merchant-ad-config\"><path d=\"M104.6 222.3V716h814.8V222.3H104.6zM873.4 670H150.6V268.3h722.8V670z\" p-id=\"986\" /><path d=\"M351.7 517.3h75.1l27.6 89.4H504l-91.2-275.5h-47.2l-90.4 275.5H324l27.7-89.4z m60.9-46h-46.7l23.4-75.7 23.3 75.7z m343.2-0.2v-3.8c0-74.9-61-135.9-135.9-135.9h-95.5V607h95.5c74.9 0 135.9-61 135.9-135.9z m-185.4-93.7h49.5c49.6 0 89.9 40.3 89.9 89.9v3.8c0 49.6-40.3 89.9-89.9 89.9h-49.5V377.4zM127.3 755.7h769.1v46H127.3z\" p-id=\"987\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/merchant-ad-config.svg
// module id = 5G87
// module chunks = 115